<h1 class="visually-hidden">{{ 'orders.newKnowYourCustomerOrder' | transloco }}</h1>
<div class="padding">
    <div class="flex-container">
        <div class="flex-item">
            <div class="margin-sides-15">
                <mat-card>
                    <mat-card-content>
                        <mat-stepper>
                            <ng-template matStepperIcon="edit">
                                <mat-icon>edit</mat-icon>
                            </ng-template>
                            <mat-step [label]="'orders.orderInfo' | transloco" completed="false" state="edit">
                                <div class="padding">
                                    <form [formGroup]="baseOrderDetails" class="padding">
                                        <div class="flex-container">
                                            <mat-form-field class="flex-item form-field" appearance="outline">
                                                <mat-label>{{ 'common.labels.referenceNumber' | transloco }}</mat-label>
                                                <input matInput [formControlName]="'referenceNumber'"
                                                    [placeholder]="'common.labels.referenceNumber' | transloco" data-testid="reference-number-field">
                                                <mat-error>{{ 'orders.referenceNumberIsRequired' | transloco }}</mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="flex-container">
                                            <mat-form-field class="flex-item form-field" appearance="outline">
                                                <mat-label>{{ 'common.labels.orderType' | transloco }}</mat-label>
                                                <mat-select [formControlName]="'orderTypeID'"
                                                    (selectionChange)="onOrderTypeSelectionChange()"
                                                    data-testid="order-type-dropdown">
                                                    @for (orderType of orderTypes; track orderType) {
                                                    <mat-option [value]="orderType.value"
                                                        [attr.data-testid]="'order-type-option-' + orderType.label.replaceAll(' ', '-').toLowerCase()">
                                                        {{orderType.label}}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                            @if (baseOrderDetails.get('country')?.value) {
                                            <mat-form-field class="flex-item form-field" appearance="outline">
                                                <mat-label>{{ 'common.labels.country' | transloco }}</mat-label>
                                                <mat-select [formControlName]="'country'" data-testid="country-dropdown"
                                                    (selectionChange)="onCountryChange()">
                                                    @for (country of countries; track country) {
                                                    <mat-option [value]="country.countryCode"
                                                        [attr.data-testid]="'country-option-' + country.countryFullName.toLowerCase()">
                                                        {{country.countryFullName}}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                            }
                                        </div>
                                        @if (userGroups.length > 1) {
                                        <div class="flex-container" [@scaleInCenter]>
                                            <mat-form-field appearance="outline" class="flex-item form-field">
                                                <mat-label>{{ 'orders.requestFor' | transloco }}</mat-label>
                                                <mat-select [formControlName]="'userGroupID'">
                                                    @for (userGroup of userGroups; track userGroup) {
                                                    <mat-option [value]="userGroup.value">
                                                        {{userGroup.label}}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        }
                                        @if (bundles.length > 1) {
                                        <div class="flex-container" [@scaleInCenter]>
                                            <mat-form-field appearance="outline" class="flex-item form-field">
                                                <mat-label>{{ 'orders.addToBundle' | transloco }}</mat-label>
                                                <mat-select [formControlName]="'bundleID'">
                                                    <mat-option [value]="null">{{ 'orders.none' | transloco }}</mat-option>
                                                    @for (bundle of bundles; track bundle) {
                                                    <mat-option [value]="bundle.value">
                                                        {{bundle.label}}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        }
                                    </form>
                                </div>
                                <!-- Navigation buttons -->
                                <div class="flex-container padding-top">
                                    <span class="spacer"></span>
                                    <span class="spacer"></span>
                                    <span class="spacer"></span>
                                    <span class="spacer"></span>
                                    <span class="spacer"></span>
                                    <button mat-raised-button (click)="saveContents()" color="primary"
                                        class="apply-padding flex-item form-field" [attr.aria-label]="'orders.nextStepButton' | transloco"
                                        data-testid="order-info-next-button">
                                        {{ 'common.buttons.next' | transloco }}
                                    </button>
                                </div>
                            </mat-step>
                        </mat-stepper>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>